/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Kanban_View_AriaInputs */

const en_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban view`)
};

const fr_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue kanban`)
};

const de_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban-Ansicht`)
};

const it_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista Kanban`)
};

const ru_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Канбан-представление`)
};

const es_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista Kanban`)
};

const zh_cn2_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看板视图`)
};

const ja_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンバンビュー`)
};

const hi_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कानबन दृश्य`)
};

const pt_pt2_explorer_display_kanban_view_aria = /** @type {(inputs: Explorer_Display_Kanban_View_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão Kanban`)
};

/**
* | output |
* | --- |
* | "Kanban view" |
*
* @param {Explorer_Display_Kanban_View_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_kanban_view_aria = /** @type {((inputs?: Explorer_Display_Kanban_View_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Kanban_View_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_kanban_view_aria(inputs)
	if (locale === "de") return de_explorer_display_kanban_view_aria(inputs)
	if (locale === "it") return it_explorer_display_kanban_view_aria(inputs)
	if (locale === "ru") return ru_explorer_display_kanban_view_aria(inputs)
	if (locale === "es") return es_explorer_display_kanban_view_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_kanban_view_aria(inputs)
	if (locale === "ja") return ja_explorer_display_kanban_view_aria(inputs)
	if (locale === "hi") return hi_explorer_display_kanban_view_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_kanban_view_aria(inputs)
	return en_explorer_display_kanban_view_aria(inputs)
});